import { normalizeLighting } from './lightingData.js';
import { checkLightLibrarySize } from './lightingLimits.js';

export const LIGHT_LIBRARY_FORMAT = 'aviseraplanner-light-library';
const RETIRED_LIGHT_LIBRARY_FORMAT = `${['sight', 'line'].join('')}-light-library`;
export function portableLight(definition) {
  const { id, ...value } = normalizeLighting({ definitions: [{ ...definition, id: 'validation' }] }).definitions[0];
  return value;
}
export function parseLightLibrary(input) {
  if (!input || ![LIGHT_LIBRARY_FORMAT, RETIRED_LIGHT_LIBRARY_FORMAT].includes(input.format) || input.version !== 1 || !Array.isArray(input.definitions) || !input.definitions.length) throw new Error('Choose an Avisera Planner light library JSON file containing at least one definition.');
  checkLightLibrarySize(input.definitions);
  if (input.definitions.some(d => !d || !['ies', 'cone'].includes(d.kind))) throw new Error('Every light needs supported IES or estimated cone photometry.');
  const values = normalizeLighting({ definitions: input.definitions.map((d, i) => ({ ...d, id: String(i) })) }).definitions.map(({ id, ...value }) => value);
  if (values.some(d => !d.libraryKey) || new Set(values.map(d => d.libraryKey)).size !== values.length) throw new Error('Light library definitions need distinct library keys.');
  return values;
}
export const exportLightLibrary = definitions => ({ format: LIGHT_LIBRARY_FORMAT, version: 1, definitions: definitions.map(portableLight) });
export const sameLight = (a, b) => JSON.stringify(portableLight(a)) === JSON.stringify(portableLight(b));

export function previewLightImport(existing, definitions, choices = {}) {
  return definitions.map((incoming, i) => {
    const before = existing.find(d => d.libraryKey === incoming.libraryKey);
    const identical = before && sameLight(before, incoming), choice = choices[i] || 'keep';
    const beforeValue = before ? portableLight(before) : null;
    const changed = before ? Object.keys(incoming).filter(k => k !== 'libraryKey' && JSON.stringify(beforeValue[k]) !== JSON.stringify(incoming[k])) : [];
    return { index: i, incoming, before, changed, conflict: !!before && !identical,
      action: !before ? 'add' : identical ? 'unchanged' : choice === 'replace' ? 'replace' : choice === 'copy' ? 'copy' : 'keep' };
  });
}

// Site definitions are immutable snapshots of the library at import. Replacement
// retains the site's id so all placed instances keep the correct reference.
export function importSiteLights(lighting, definitions, choices, newId) {
  const rows = previewLightImport(lighting.definitions, definitions, choices), next = [...lighting.definitions];
  for (const row of rows) {
    if (row.action === 'add' || row.action === 'copy') next.push({ ...row.incoming, id: newId(), ...(row.action === 'copy' ? { libraryKey: newId(), name: `${row.incoming.name} (copy)`.slice(0, 160) } : {}) });
    if (row.action === 'replace') next[next.findIndex(d => d.id === row.before.id)] = { ...row.incoming, id: row.before.id };
  }
  return normalizeLighting({ ...lighting, definitions: next });
}
